import type { Question, QuestionType, Quiz } from './model.js';

/**
 * Pure helpers over the quiz model, deliberately free of any zod import.
 *
 * The published player consumes these, and pulling the schema module in with
 * them would put a validation library the runtime never calls into every
 * course package. Schemas belong to authoring; the player only reads data that
 * the publisher already validated.
 */

export const P0_QUESTION_TYPES = [
  'multipleChoice',
  'multipleResponse',
  'trueFalse',
  'fillInTheBlank',
  'numeric',
  'matching',
] as const;

export type P0QuestionType = (typeof P0_QUESTION_TYPES)[number];

export function isP0QuestionType(t: QuestionType): t is P0QuestionType {
  return (P0_QUESTION_TYPES as readonly string[]).includes(t);
}

const GRADEABLE_TYPES: ReadonlySet<string> = new Set(P0_QUESTION_TYPES);

/** Types the player can score today. Others are carried but excluded from totals. */
export function isGradeable(question: Question): boolean {
  return GRADEABLE_TYPES.has(question.type);
}

export function totalPoints(quiz: Pick<Quiz, 'questions'>): number {
  return quiz.questions.reduce((sum, q) => sum + q.points, 0);
}

/** The identifier reported to the LMS, falling back to the internal id. */
export function reportingIdOf(question: Question): string {
  return question.reportingId ?? question.id;
}
